import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import verticalRhythm from 'compass-vertical-rhythm';
import ms from 'modularscale';
import assign from 'object-assign';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

var heading = {
  fontFamily: 'heading',
  lineHeight: 'heading',
  fontWeight: 'heading'
};
var styles = {
  root: {
    fontFamily: 'body',
    fontSize: 2,
    fontWeight: 'body',
    lineHeight: 'body'
  },
  img: {
    maxWidth: '100%'
  },
  h1: assign({
    fontSize: 5
  }, heading),
  h2: assign({
    fontSize: 4
  }, heading),
  h3: assign({
    fontSize: 3
  }, heading),
  h4: assign({
    fontSize: 2
  }, heading),
  h5: assign({
    fontSize: 1
  }, heading),
  h6: assign({
    fontSize: 0
  }, heading),
  ul: {
    listStylePosition: 'outside',
    listStyleImage: 'none',
    ml: 3
  },
  ol: {
    listStylePosition: 'outside',
    listStyleImage: 'none',
    ml: 3
  },
  li: {
    mb: 2,
    pl: 0,
    ol: {
      my: 2,
      ml: 3
    },
    ul: {
      my: 2,
      ml: 3
    },
    p: {
      mb: 2
    }
  },
  p: {},
  table: {
    borderCollapse: 'collapse',
    width: '100%'
  },
  th: {
    textAlign: 'left',
    borderBottom: '1px solid',
    px: 2,
    py: 1,
    ':first-child': {
      pl: 0
    },
    ':last-child': {
      pr: 0
    }
  },
  td: {
    textAlign: 'left',
    borderBottom: '1px solid',
    px: 2,
    py: 1,
    mt: '-1px',
    ':first-child': {
      pl: 0
    },
    ':last-child': {
      pr: 0
    }
  },
  blockquote: {
    mx: 3
  },
  hr: {
    border: 0,
    borderBottom: '1px solid',
    mt: '-1px',
    mb: 3
  },
  b: {
    fontWeight: 'bold'
  },
  strong: {
    fontWeight: 'bold'
  },
  code: {
    fontSize: '85%'
  },
  pre: {
    fontSize: '85%',
    padding: 3
  }
};
var headings = ['h6', 'h5', 'h4', 'h3', 'h2', 'h1'];
var blockElements = [].concat(headings, ['ul', 'ol', 'p', 'pre', 'table', 'blockquote', 'img', 'hr']);
blockElements.forEach(function (tag) {
  assign(styles, _defineProperty({}, tag, assign({
    padding: 0,
    margin: 0,
    marginBottom: 3
  }, styles[tag])));
}); // - creates base theme object
// - uses a static theme.styles object for consumption in theme-ui
// - ignores overrideThemeStyles
// - does not include color styles
// - should be mostly compatible with existing typography.js themes

var defaults = {
  baseFontSize: 16,
  baseLineHeight: 1.45,
  headerLineHeight: 1.1,
  scaleRatio: 2,
  googleFonts: [],
  headerFontFamily: ['-apple-system', 'BlinkMacSystemFont', 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', 'sans-serif'],
  bodyFontFamily: ['georgia', 'serif'],
  headerWeight: 'bold',
  bodyWeight: 'normal',
  boldWeight: 'bold',
  includeNormalize: true,
  blockMarginBottom: 1
};

var toUnitless = function toUnitless(val) {
  return parseFloat(val);
};

var getScale = function getScale(opts) {
  return function (value) {
    return ms(value, opts.scaleRatio) * opts.baseFontSize;
  };
};

var getSpace = function getSpace(result, opts) {
  var n = toUnitless(result.rhythm(opts.blockMarginBottom));
  return [0, 1 / 4, 1 / 2, 1, 2, 4, 8].map(function (v) {
    return v * n;
  });
};

var stackFonts = function stackFonts(fonts) {
  return fonts.map(function (font) {
    return "\"".concat(font, "\"");
  }).join(', ');
};

var getFonts = function getFonts(result, opts) {
  var body = stackFonts(opts.bodyFontFamily);
  var heading = stackFonts(opts.headerFontFamily);
  return {
    body: body,
    heading: heading
  };
};

var getFontSizes = function getFontSizes(result, opts) {
  var scale = getScale(opts);
  return [-1.5 / 5, -1 / 5, 0, 2 / 5, 3 / 5, 1].map(scale);
};

var getLineHeights = function getLineHeights(result, opts) {
  var body = opts.baseLineHeight;
  var heading = opts.headerLineHeight;
  return {
    body: body,
    heading: heading
  };
};

var getFontWeights = function getFontWeights(result, opts) {
  var body = opts.bodyWeight;
  var bold = opts.boldWeight;
  var heading = opts.headerWeight;
  return {
    body: body,
    bold: bold,
    heading: heading
  };
};

var toTheme = function toTheme() {
  var _opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var opts = _objectSpread({}, defaults, _opts); // enforce unitless values


  opts.baseFontSize = toUnitless(opts.baseFontSize);
  opts.rhythmUnit = 'px';
  var typo = verticalRhythm(opts);
  var theme = {};
  typo.options = opts;
  theme.space = getSpace(typo, opts);
  theme.fonts = getFonts(typo, opts);
  theme.fontSizes = getFontSizes(typo, opts);
  theme.fontWeights = getFontWeights(typo, opts);
  theme.lineHeights = getLineHeights(typo, opts);
  return _objectSpread({}, theme, {
    styles: styles,
    typography: typo
  });
};

export { toTheme, styles };